export const ROUTE_PATH = {
  SERVICE_LIST: '/services',
  EVENT_LIST: '/events',
  EVENT_DETAIL: '/events/[eventId]/info',
} as const;

const SERVICE_TITLE = 'Status Board | 카카오클라우드 서비스 상태';
const EVENT_TITLE = 'Status Board | 카카오클라우드 이벤트 내역';
const SERVICE_DESCRIPTION =
  'Status Board에서 카카오클라우드 서비스의 상태와 주요 이벤트를 확인하세요.';

/**
 * Router Config 파라미터
 * Breadcrumb에서 동적 라벨 표시 시 사용
 */
interface RouterConfigParams {
  eventTitle?: string;
}

/**
 * Breadcrumb에서 사용하는 라우터 설정을 반환합니다.
 * @param params - 동적 라벨 표시를 위한 파라미터
 * @returns 라우트 경로별 라벨 매핑 객체
 * @example
 * const routerConfig = getRouterConfig({ eventTitle: '이벤트 제목' });
 */
export const getRouterConfig = (params?: RouterConfigParams) => {
  return {
    [ROUTE_PATH.SERVICE_LIST]: '서비스 상태',
    [ROUTE_PATH.EVENT_LIST]: '이벤트 내역',
    [ROUTE_PATH.EVENT_DETAIL]: params?.eventTitle || '',
  };
};

/**
 * 서비스의 공통 상수를 반환합니다.
 * @returns 서비스 타이틀, 경로, 이름을 포함한 객체
 * @example
 * const { SERVICE_TITLE, SERVICE_DESCRIPTION } = getServiceConstants();
 */
export const getServiceConstants = () => ({
  SERVICE_TITLE,
  EVENT_TITLE,
  SERVICE_DESCRIPTION,
});
